import dataProvider from "../../../../../providers/data-provider";
import { ProfileEnum } from "../../../../../utils/general-profile.enum";
import DashboardFilter from "./dashboard-filter";

const fetchInstitutionBranches = async (shouldFetch, search, institutionId) => {
    if (shouldFetch) {
        const response = await dataProvider.getList(
            'institution-branches',
            {
                pagination: { page: 1, perPage: 20 },
                sort: { field: 'name', order: 'ASC' },
                filter: { name: search, [`institution.id`]: institutionId }
            })
        return response.data;
    } else { return [] }
}

export const InstitutionBranchFilter = ({ profile, filters, setFilters }) => {

    const shouldFetch = profile === ProfileEnum.SUPERADMIN ? filters.institutionId : true

    return <DashboardFilter
        filterKey="institutionBranchId"
        label="Unidade"
        value={filters?.institutionBranch?.id}
        setFilters={setFilters}
        fetchOptions={(search) => fetchInstitutionBranches(shouldFetch, search, filters?.institutionId)}
        disabled={!shouldFetch}
    />
}